(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  };

  onReady(() => {
    const header = () => {
      const body = document.querySelector('body');
      const headerEl = document.querySelector('.header');
      const openBtn = document.querySelector('.header__offcanvas-toggle');
      const closeBtn = document.querySelector('.header__offcanvas-toggle-link--close');
      const offMenu = document.querySelector('.header__offcanvas-menu');
      const searchDetails = document.querySelector('.header__details');
      const submenuDetails = document.querySelectorAll('.header__submenu li details');
      const headerHiddenMenu = document.querySelector('.header__inline-menu');
      const openSearchBtn = document.querySelector('.header__search');

      if (!body || !headerEl || !openBtn || !closeBtn || !offMenu || !headerHiddenMenu) {
        return;
      }

      const getOffcanvas = () => document.querySelector('.header__offcanvas');

      const openMenu = (event) => {
        event.preventDefault();
        offMenu.classList.remove('header__offcanvas-menu--close');
        offMenu.classList.add('header__offcanvas-menu--open');
        openBtn.classList.add('active');
        body.classList.add('body--hidden');
        closeBtn.style.display = 'block';
        openBtn.style.display = 'none';
        headerHiddenMenu.style.display = 'none';
        const offcanvasElement = getOffcanvas();
        if (offcanvasElement) offcanvasElement.style.visibility = 'visible';
      };

      const closeMenu = () => {
        offMenu.classList.remove('header__offcanvas-menu--open');
        offMenu.classList.add('header__offcanvas-menu--close');
        openBtn.classList.remove('active');
        body.classList.remove('body--hidden');
        body.classList.remove('overflow-hidden-tablet');
        closeBtn.style.display = 'none';
        openBtn.style.display = 'block';
        headerHiddenMenu.style.display = window.innerWidth >= 1100 ? 'block' : 'none';
        const offcanvasElement = getOffcanvas();
        if (offcanvasElement) {
          offcanvasElement.style.visibility = window.innerWidth >= 1100 ? 'visible' : 'hidden';
        }
        headerEl.classList.remove('search-header--opened');
      };

      openBtn.addEventListener('click', openMenu);
      closeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        closeMenu();
      });

      window.addEventListener('resize', () => {
        const offcanvasElement = getOffcanvas();
        if (window.innerWidth >= 1100) {
          if (!openBtn.classList.contains('active')) headerHiddenMenu.style.display = 'block';
          if (offcanvasElement) offcanvasElement.style.visibility = 'visible';
          body.classList.remove('body--hidden');
          body.classList.remove('overflow-hidden-tablet');
          if (openBtn.classList.contains('active')) closeMenu();
        } else {
          headerHiddenMenu.style.display = 'none';
          if (offcanvasElement) offcanvasElement.style.visibility = 'hidden';
          if (openBtn.classList.contains('active')) body.classList.add('body--hidden');
        }
      });

      submenuDetails.forEach((targetDetail) => {
        targetDetail.addEventListener('click', () => {
          submenuDetails.forEach((detail) => {
            if (detail !== targetDetail) {
              detail.removeAttribute('open');
              headerEl.classList.remove('search-header--opened');
            }
          });
        });
      });

      document.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;
        closeMenu();
        if (searchDetails) searchDetails.removeAttribute('open');
        body.classList.remove('overflow-hidden');
        body.classList.remove('search-overflow-hidden');
        headerEl.classList.remove('search-header--opened');
      });

      if (openSearchBtn && searchDetails && headerHiddenMenu) {
        openSearchBtn.addEventListener('click', () => {
          if (searchDetails.open) {
            body.classList.add('overflow-hidden');
            body.classList.add('search-overflow-hidden');
            headerEl.classList.add('search-header--opened');
            return;
          }
          body.classList.remove('overflow-hidden');
          body.classList.remove('search-overflow-hidden');
          headerEl.classList.remove('search-header--opened');
          const offcanvasElement = getOffcanvas();
          if (offcanvasElement) {
            offcanvasElement.style.visibility = window.innerWidth >= 1100 ? 'visible' : 'hidden';
          }
          headerHiddenMenu.style.display = window.innerWidth >= 1100 ? 'block' : 'none';
        });
      }

      const headerOverlayAlways = document.querySelector('.header.overlay');
      if (window.jQuery) {
        window.jQuery(window).scroll(function () {
          if (!headerOverlayAlways) return;
          if (window.jQuery(this).scrollTop() > 50) {
            window.jQuery('.header').addClass('header_overlay-scroll');
          } else {
            window.jQuery('.header').removeClass('header_overlay-scroll');
          }
        });
      }

      const megaMenus = document.querySelectorAll('.mega-submenu-with-tabs');
      function setupSizing(menu) {
        const tabsList = menu.querySelector('.mega-submenu-with-tabs__tabs-list');
        const tabs = Array.from(menu.querySelectorAll('.mega-submenu-with-tabs__tab'));
        if (!tabsList || tabs.length === 0) return;
        let maxH = 0;
        tabs.forEach((tab) => {
          const prevVis = tab.style.visibility;
          const prevPos = tab.style.position;
          tab.style.visibility = 'hidden';
          tab.style.position = 'static';
          maxH = Math.max(maxH, tab.offsetHeight);
          tab.style.visibility = prevVis;
          tab.style.position = prevPos;
        });
        const capH = parseFloat(window.getComputedStyle(tabsList).maxHeight);
        tabsList.style.height = `${Math.min(maxH, capH)}px`;
      }

      function setupPosition(menu) {
        menu.style.left = '0';
        const menuRight = menu.getBoundingClientRect().right;
        if (menuRight >= document.body.clientWidth) {
          menu.style.left = `${document.body.clientWidth - menuRight - 20}px`;
        }
      }

      megaMenus.forEach((menu) => {
        const childItems = Array.from(menu.querySelectorAll('.mega-submenu-with-tabs__child-item'));
        const tabs = Array.from(menu.querySelectorAll('.mega-submenu-with-tabs__tab'));
        const clearActive = () => {
          childItems.forEach((ci) => ci.classList.remove('active'));
          tabs.forEach((tab) => tab.classList.remove('active'));
        };
        childItems.forEach((item) => {
          item.addEventListener('mouseenter', () => {
            clearActive();
            item.classList.add('active');
            const tabId = item.id;
            const match = menu.querySelector(`.mega-submenu-with-tabs__tab[data-menu-tab-id="${tabId}"]`);
            if (match) match.classList.add('active');
          });
        });
        setupSizing(menu);
        setupPosition(menu);
      });

      const sectionHeader = document.querySelector('.shopify-section-header');
      if (sectionHeader && window.ResizeObserver) {
        let headerElWidth = sectionHeader.offsetWidth;
        new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.contentRect.width !== headerElWidth) {
              megaMenus.forEach(setupPosition);
              headerElWidth = entry.contentRect.width;
            }
          });
        }).observe(sectionHeader);
      }

      const offcanvasElement = getOffcanvas();
      headerHiddenMenu.style.display = window.innerWidth >= 1100 ? 'block' : 'none';
      if (offcanvasElement) {
        offcanvasElement.style.visibility = window.innerWidth >= 1100 ? 'visible' : 'hidden';
      }
    };

    const closeSearchButton = document.querySelector('.search-modal-close-button');
    closeSearchButton?.addEventListener('click', () => {
      const headerEl = document.querySelector('.header');
      headerEl?.classList.remove('search-header--opened');
      document.querySelector('.header__details')?.removeAttribute('open');
    });

    const searchTabs = document.querySelectorAll('.predictive-search__result-tab');
    const results = document.querySelectorAll('.search__items-list');
    if (results.length && searchTabs.length) {
      results[0].classList.add('active');
      searchTabs[0].classList.add('active');
    }
    searchTabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const typeTarget = tab.dataset.typeTarget;
        searchTabs.forEach((element) => element.classList.remove('active'));
        tab.classList.add('active');
        results.forEach((element) => {
          element.classList.toggle('active', element.dataset.type === typeTarget);
        });
      });
    });

    const announcementBar = document.querySelector('.announcement-bar');
    const headerOffcanvas = document.querySelector('.header__offcanvas-wrapper');
    if (announcementBar && headerOffcanvas) headerOffcanvas.classList.add('announcement-bar-show');
    if (window.jQuery) {
      window.jQuery(window).scroll(function () {
        if (!announcementBar || !headerOffcanvas) return;
        if (window.jQuery(window).scrollTop() > 100) {
          headerOffcanvas.classList.add('announcement-bar-hide');
          headerOffcanvas.classList.remove('announcement-bar-show');
        } else {
          headerOffcanvas.classList.remove('announcement-bar-hide');
          headerOffcanvas.classList.add('announcement-bar-show');
        }
      });
    }

    document.addEventListener('shopify:section:load', header);
    header();

    if (window.screen.width > 990) {
      let attachedHeader = false;
      const headerSection = document.querySelector('.shopify-section-header');
      const imageContainerHeader = headerSection?.querySelector('.button--with-underline--container');
      const followMouseHeader = (event) => {
        if (!imageContainerHeader || !headerSection) return;
        imageContainerHeader.style.left = `${event.pageX}px`;
        imageContainerHeader.style.top = `${event.pageY - window.scrollY - headerSection.offsetHeight + 30}px`;
      };
      window.showTextHeader = function () {
        if (!attachedHeader && imageContainerHeader) {
          attachedHeader = true;
          imageContainerHeader.style.display = 'block';
          document.addEventListener('pointermove', followMouseHeader);
        }
      };
      window.hideTextHeader = function () {
        if (imageContainerHeader) {
          attachedHeader = false;
          imageContainerHeader.style.display = '';
          document.removeEventListener('pointermove', followMouseHeader);
        }
      };
    }
  });
})();
